import { render } from "./LbList.vue?vue&type=template&id=021d48c7&scoped=true"
import script from "./LbList.vue?vue&type=script&lang=js"
export * from "./LbList.vue?vue&type=script&lang=js"

import "./LbList.vue?vue&type=style&index=0&id=021d48c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021d48c7"]])

export default __exports__